import { Component, OnInit, NgIterable } from "@angular/core";
import { DataService } from "src/app/services/data.services";
export interface loaderViewModel {
  show: boolean;
  data?: loaderViewModelData[];
  title?: string;
  sub_title?: string;
  icon?: string;
}
export interface loaderViewModelData {
  key: string;
  value: any | NgIterable<any>;
}

@Component({
    selector: "cw-main-screen-loader",
    templateUrl: "./main-screen-loader.component.html",
    styleUrls: ["./main-screen-loader.component.scss"],
    standalone: false
})
export class MainScreenLoaderComponent implements OnInit {
  screenLoaderData?: loaderViewModel;
  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.screenLoaderData = undefined;
    this.dataService.screenLoaderDataSubjectCast.subscribe(
      (data: loaderViewModel) => {
        if (data) {
          this.screenLoaderData = data;
        }
      }
    );
  }

  checkTypeOf(value: any) {
    return typeof value;
  }
}
